import PropTypes from 'prop-types';

import choiceData from './choiceData';

/**
 * PropTypes for all choices in step 1
 */
export default PropTypes.shape({
    dates:choiceData,
    models: choiceData,
    body_styles: choiceData,
    commercial_names: choiceData,
    engines: choiceData,
    transmissions: choiceData,
    rimsLabel :choiceData,
    rimsCode : choiceData
});


// WEBPACK FOOTER //
// ./src/propTypes/choices.js